<template>
  <div class='h100-40 width-100vw noPage'>
    <ejs-grid ref='grid' height='calc(100% - 0px)' :dataSource='data' :contextMenuItems='contextMenuItems' :contextMenuOpen='menuBeforeOpenFunc' :contextMenuClick='menuClickFunc'
      :selectionSettings='selectionOptions' :allowReordering='true' :allowResizing='true'>
      <e-columns>
        <e-column type='checkbox'  textAlign='Center' width='66'></e-column>
        <!-- <e-column field='systemType' :headerText='$t("Alarm.sysType")' textAlign='Center' width='6%' clipMode='EllipsisWithTooltip'></e-column> -->
        <e-column field='level' :headerText='$t("Alarm.alarmLevel")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter='levelFormat'></e-column>
        <e-column field='alarmType' :headerText='$t("Alarm.alarmType")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :formatter='alarmTypeFormat'></e-column>
        <e-column field='neType' :headerText='$t("Alarm.neType")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='description' :headerText='$t("Alarm.alarmDec")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='solution' :headerText='$t("Alarm.advise")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='redefineState' :headerText='$t("Alarm.status")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :formatter='statusFormat'></e-column>
      </e-columns>
    </ejs-grid>
    <CustomDialog ref='editDialog' :element='editDialogSetting.element' :styles='editDialogSetting.styles'>
      <template v-slot:dialog-content>
        <AlarmRedirect ref='editContent'></AlarmRedirect>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import { Reorder, Resize, ContextMenu } from '@syncfusion/ej2-vue-grids';
import CustomDialog from '../../common/CustomDialog';
import AlarmRedirect from './AlarmRedirect';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'alarmRedirectTable',
  components: {
    CustomDialog,
    AlarmRedirect
  },
  data() {
    return {
      selectionOptions: { type: 'Multiple' },
      queryConditions: {
        systemId: '1',
        keywords: ''
      },
      showType: '',
      data: [],
      contextMenuItems: [{
        text: `${this.$t('Alarm.edit')}`
      }],
      editDialogSetting: {
        styles: {
          width: '400px',
          height: 'auto',
          model: true,
          visible: false
        },
        element: {
          title: this.$t('Alarm.redefineModigy'),
          target: '#app',
          refName: 'edit',
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Alarm.cancel') } },
            { click: this.editConfirmFunc, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } }
          ]
        }
      }
    };
  },
  provide: {
    grid: [Reorder, Resize, ContextMenu]
  },
  methods: {
    levelFormat(grids, data) {
      if (data.level || data.level === 0) {
        return this.$t(`Alarm.alarmLevel_${data.level}`);
      }
      return '';
    },
    alarmTypeFormat(grids, data) {
      if (data.alarmType || data.alarmType === 0) {
        return this.$t(`Alarm.alarmType_${data.alarmType}`);
      }
      return '';
    },
    statusFormat(grids, data) {
      if (data.redefineState && data.redefineState > 0) {
        return this.$t(`Alarm.alarmredefned_${data.redefineState}`);
      }
      return '';
    },
    menuBeforeOpenFunc(menuArgs) { // 屏蔽表头的右键事件
      if ((!menuArgs.rowInfo.rowIndex && menuArgs.rowInfo.rowIndex !== 0) || this.getCheckedData(true).length > 1) {
        menuArgs.cancel = true;
      }
    },
    menuClickFunc(menuArgs) { // 为右键分配事件
      switch (menuArgs.element.innerText) {
        case `${this.$t('Alarm.edit')}`:
          this.editFunc();
          break;
        default:
      }
    },
    dialogHide() {
      this.$refs.editDialog.clear();
      this.$refs.editDialog.close();
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.no_checked')});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.onlyOneSelect')});
        return false;
      }
      return selectedRecords;
    },
    getCheckedVals() {
      const alarmIDList = [];
      const neTypeIDList = [];
      const checkedData = this.getCheckedData(true);
      for (let i = 0; i < checkedData.length; i++) {
        alarmIDList.push(checkedData[i].alarmID);
        neTypeIDList.push(checkedData[i].neTypeId);
      }
      return {
        alarmId: alarmIDList,
        neTypeId: neTypeIDList
      };
    },
    getAlarmListData() {
      // 获取表格数据
      const This = this;
      let url = '/lte/ems/background/alarmredefinefusion/query';
      if (!This.showType) {
        This.showType = '';
      }
      if (!This.queryConditions.keywords) {
        This.queryConditions.keywords = '';
      }
      const params = { params: {
          showType: This.showType,
          gjsstj: This.queryConditions.keywords,
        } };
      // url = `${url}?showType=${This.showType}&gjsstj=${This.queryConditions.keywords}`;
      This.$axios.get(url, params).then((response) => {
        if (response && response.status === 200) {
          This.data = response.data.alarmRedefinedList;
        }
      });
    },
    editFunc() {
      const checkedData = this.getCheckedData(false);
      if (checkedData) {
        this.$refs.editContent.clear();
        this.$refs.editDialog.show();
        this.$refs.editContent.setAlarmId(checkedData);
      }
    },
    editConfirmFunc() {
      const editData = this.$refs.editContent.getdata();
      const checkedData = this.getCheckedData(false);
      if (editData) {
        if (editData.level !== checkedData[0].level || editData.description !== checkedData[0].description || editData.solution !== checkedData[0].solution) {
          this.$axios.post('/lte/ems/background/alarmredefinefusion/update', editData).then((response) => {
            if (response && response.status === 200) {
              let successStr = '';
              let errorStr = '';
              Object.entries(response.data).forEach((value) => {
                if (value[1] === 0) {
                  successStr += `${value[0]} `;
                } else {
                  errorStr += `${value[0]} `;
                }
              });
              console.log(successStr);
              if (errorStr === '') {
                this.dialogHide();
                EventBus.$emit('toast', {type: 'success', content: this.$t('Alarm.alreadyModifiedSystem')});
                this.getAlarmListData();
              } else {
                EventBus.$emit('toast', {type: 'error', content: `${this.$t('Alarm.modifiedSystemFailed')}:${errorStr}`});
              }
            } else {
              EventBus.$emit('toast', {type: 'error', content: this.$t('Alarm.error')});
            }
          });
        } else {
          this.dialogHide();
          this.getAlarmListData();
        }
      }
    },
    resetFunc() {
      const checkedData = this.getCheckedData(true);
      if (checkedData) {
        this.$layer.confirm({
          msg: `${this.$t('Alarm.confirmGhost')}`,
          btn1: {
            msg: this.$t('Track.cancel')
          },
          btn2: {
            msg: this.$t('Alarm.confirm'),
            func: () => {
              this.$axios.post('/lte/ems/background/alarmredefinefusion/ghost.html', {
                alarmId: this.getCheckedVals().alarmId,
                neTypeId: this.getCheckedVals().neTypeId
              }).then((response) => {
                if (response && response.status === 200) {
                  let successStr = '';
                  let errorStr = '';
                  Object.entries(response.data).forEach((value) => {
                    if (value[1] === 0) {
                      successStr += `${value[0]} `;
                    } else {
                      errorStr += `${value[0]} `;
                    }
                  });
                  console.log(successStr);
                  if (errorStr === '') {
                    EventBus.$emit('toast', {type: 'success', content: this.$t('Alarm.ghostAllSystem')});
                  } else {
                    EventBus.$emit('toast', {type: 'error', content: `${this.$t('Alarm.fhostSystemFailed')}:${errorStr}`});
                  }
                } else {
                  EventBus.$emit('toast', {type: 'error', content: this.$t('Alarm.error')});
                }
                this.getAlarmListData();
              });
            }
          }
        });
      }
    }
  },
  mounted() {
    this.getAlarmListData();
  }
};
</script>
